import { Scene } from 'phaser';
import { BotaoArcade } from '../components/BotaoArcade';
import { desenharFaixaComRessalto, desenharFundo } from '../components/cenario';
import { SCENES } from '../config/constants';
import { ARCADE_TEXT } from '../config/theme';

/**
 * Marcador das telas que ainda não foram entregues (plano `tablet-frontend`,
 * TF2/TF5/TF6). Existe para o fluxo ser navegável de ponta a ponta; some
 * quando a última cena real entrar.
 */
export class EmBreveScene extends Scene {
    constructor () {
        super(SCENES.EM_BREVE);
    }

    create ({ titulo = 'Em breve' } = {}) {
        desenharFundo(this);
        desenharFaixaComRessalto(this);

        this.add.text(639.5, 330, titulo.toUpperCase(), {
            ...ARCADE_TEXT.botao, fontSize: '44px', letterSpacing: -4.4
        }).setOrigin(0.5);
        this.add.text(639.5, 410, 'Esta tela entra em uma próxima entrega.', ARCADE_TEXT.subtitulo)
            .setOrigin(0.5);

        new BotaoArcade(this, 639.5, 540, {
            rotulo: 'VOLTAR', aoClicar: () => this.scene.start(SCENES.AGUARDE, {})
        });
    }
}
